if (!customElements.get('tab-container')) {
  customElements.define(
    'tab-container',
    class TabContainer extends HTMLElement {
      constructor() {
        super();
        this.tabList = this.querySelector('[role="tablist"]');
        this.tabButtons = this.querySelectorAll('button[role="tab"]');
        this.tabPanels = this.querySelectorAll('[role="tabpanel"]');
        this.tabFocus = 0;

        this.tabButtons.forEach((button) => {
          button.addEventListener('click', (e) => {
            e.preventDefault();
            this.tabPanels.forEach((tabPanel) => {
              tabPanel.classList.remove('animate--slide-in');
            });
            let tabId = parseInt(button.getAttribute('aria-controls').replace('panel-', ''));
            this.selectedTab = tabId;
          });
        });

        this.selectedTab = 0;

        this.tabList.addEventListener('keydown', this.onKeydown.bind(this));
      }
      set selectedTab(id) {
        let tabLength = this.tabButtons.length - 1;
        let newId = id > tabLength ? 0 : Math.max(0, id);
        this.tabButtons.forEach((button) => {
          button.setAttribute('aria-selected', false);
          button.classList.remove('active');
          button.tabIndex = -1;
          if (button.getAttribute('aria-controls') === `panel-${newId}`) {
            button.setAttribute('aria-selected', true);
            button.classList.add('active');
            button.tabIndex = 0;
          }
        });
        this.tabPanels.forEach((panel) => {
          panel.classList.add('hidden');
          panel.tabIndex = -1;
          if (panel.getAttribute('id') === `panel-${newId}`) {
            panel.classList.remove('hidden');
            panel.tabIndex = 0;
          }
        });

        this.activeTab = newId;
      }
      get selectedTab() {
        return this.activeTab;
      }

      onKeydown(event) {
        let flag = false;
        switch (event.key) {
          case 'ArrowLeft':
            this.selectedTab = this.selectedTab - 1;
            flag = true;
            break;

          case 'ArrowRight':
            this.selectedTab = this.selectedTab + 1;
            flag = true;
            break;

          case 'Home':
            this.selectedTab = 0;
            flag = true;
            break;

          case 'End':
            this.selectedTab = this.tabButtons.length;
            flag = true;
            break;

          default:
            break;
        }

        if (flag) {
          event.stopPropagation();
          event.preventDefault();
        }
        this.tabButtons[this.selectedTab].focus();
      }
    }
  );
}

if (!customElements.get('tab-details-disclosure')) {
  customElements.define(
    'tab-details-disclosure',
    class TabDetailsDisclosure extends HTMLElement {
      constructor() {
        super();
        this.mainDetailsToggle = this.querySelector('details');
        this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

        this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
        this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
      }

      onFocusOut() {
        // setTimeout(() => {
        //   if (!this.contains(document.activeElement)) this.close();
        // });
      }

      open() {
        this.mainDetailsToggle.setAttribute('open', '');
        this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
        if (!this.animations) this.animations = this.content.getAnimations();
        this.animations.forEach((animation) => animation.play());
      }

      onToggle() {
        if (!this.animations) this.animations = this.content.getAnimations();

        if (this.mainDetailsToggle.hasAttribute('open')) {
          this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
          this.animations.forEach((animation) => animation.play());
        } else {
          this.animations.forEach((animation) => animation.cancel());
        }
      }

      close() {
        this.mainDetailsToggle.removeAttribute('open');
        this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
      }
    }
  );
}
